import React from "react";
import { Box } from "@chakra-ui/react";
import { useLocation } from "react-router-dom";
import SubscriptionRequiredModal from "./SubscriptionRequiredModal";
import PaywallBackdrop from "./PaywallBackdrop";
import { useBillingContext } from "../../contexts/BillingContext";

const PAYWALL_PATH = "/paywall";

/**
 * Renders the subscription paywall on `/paywall` and proactive redirects are handled by
 * `BillingPaywallEnforcer` plus 402 handling in `apiClient`.
 */
export default function BillingGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { isLoading, isTier1Granted } = useBillingContext();
  const pathname = location.pathname.replace(/\/+$/, "") || "/";

  if (pathname !== PAYWALL_PATH || isLoading || isTier1Granted) {
    return <>{children}</>;
  }

  return (
    <Box position="relative" minH="100%">
      <Box
        filter="blur(7px)"
        pointerEvents="none"
        userSelect="none"
        opacity={0.92}
        transition="filter 0.2s ease"
        aria-hidden
      >
        <PaywallBackdrop />
      </Box>
      <SubscriptionRequiredModal isOpen />
    </Box>
  );
}
